// import { HttpClient } from "@angular/common/http";
// import { inject, Injectable } from "@angular/core";
// import { Observable } from "rxjs";
// import { AISearchQueryRequestDTO, AskGPTWithFilesDTO, AskGPTWithFilesResponse } from "./AI.interface";

// @Injectable({
//   providedIn: "root",
// })
// export class AIService {
//   private http = inject(HttpClient);

//   AIService_SearchQuery(data: AISearchQueryRequestDTO): Observable<string> {
//     return this.http.get(
//       `https://apig.advinsoftwares.com/AI/OA/GPT/AskChatGPT`,
//       {
//         params: { query: data.query },
//         responseType: "text",
//       }
//     ) as Observable<string>;
//   }

//     AskGPTWithFilesMaster_URL(data: FormData): Observable<AskGPTWithFilesResponse> {
//       return this.http.post<AskGPTWithFilesResponse>(`https://apig.advinsoftwares.com/AI/OA/GPT/AskChatGPTWithFiles`, data)
//     }
//     AskGPTWithImageMaster_URL(data: FormData): Observable<AskGPTWithFilesResponse> {
//       return this.http.post<AskGPTWithFilesResponse>(`https://apig.advinsoftwares.com/AI/OA/GPT/AskChatGPTWithImages`, data)
//     }
// }

import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { AISearchQueryRequestDTO, AskGPTWithFilesResponse } from "./AI.interface";
import { AskGeminiMasterURL, AskGPTWithFilesMasterURL, AskGPTWithImagesMasterURL } from "src/app/GlobalVariable";


@Injectable({
  providedIn: "root",
})
export class AIService {
  private http = inject(HttpClient);

  AIService_SearchQuery(data: AISearchQueryRequestDTO): Observable<string> {
    return this.http.get(AskGeminiMasterURL, {
      params: { query: data.query },
      responseType: "text",
    }) as Observable<string>;
  }

  AskGPTWithFilesMaster_URL(data: FormData): Observable<AskGPTWithFilesResponse> {
    return this.http.post<AskGPTWithFilesResponse>(AskGPTWithFilesMasterURL, data);
  }

  AskGPTWithImageMaster_URL(data: FormData): Observable<AskGPTWithFilesResponse> {
    return this.http.post<AskGPTWithFilesResponse>(AskGPTWithImagesMasterURL, data);
  }
}
